import React, { Component, Children } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import qs from 'qs';
import { flashErrorMessage } from '../../actions/flash';
import { fetchM } from '../../actions/fetchM';
import { checkChanges } from '../../utils/checkChanges';
import {
  NEW_MAPPING_PROMPT,
} from '../../constants/promptMessages';
import { namespaces, TRANSLATION_FILES } from '../../constants/translation';

import List from './List';
import New from './New';
import Edit from './Edit';

class AffiliateMappings extends Component {
  static propTypes = {
    children: PropTypes.node,
    location: PropTypes.shape({
      pathname: PropTypes.string,
      query: PropTypes.object,
    }),
    params: PropTypes.shape({
      affiliateMappingID: PropTypes.string,
    }),
  }
  static contextTypes = {
    store: PropTypes.object,
  }

  static List = List
  static New = checkChanges(New, { message: NEW_MAPPING_PROMPT })
  static Edit = checkChanges(Edit)

  constructor(props) {
    super(props);
    this.state = {
      token: null,
      loading: true,
      data: null,
    };
  }
  componentDidMount() {
    if (this.props.params.affiliateMappingID) {
      this.fetchAffiliateMapping();
    } else if (this.props.location.pathname.includes('/new/')) {
      this.fetchAffiliateMappings();
    } else {
      this.setLoading(false);
    }
  }
  componentWillReceiveProps(nextProps) {
    const { pathname } = nextProps.location;
    if (nextProps.params.affiliateMappingID) {
      if (pathname !== this.props.location.pathname) {
        this.fetchAffiliateMapping();
      }
    } else if (pathname.includes('/new/')) {
      this.fetchAffiliateMappings();
    }
  }
  setComponentState(state = {}) {
    return new Promise((res) => {
      this.setState(state, () => {
        res(state);
      });
    });
  }
  setLoading(loading = false) {
    return new Promise((res) => {
      this.setState({ loading }, () => {
        res(loading);
      });
    });
  }
  async fetchAffiliateMapping() {
    const { t } = this.props;
    await this.setLoading(true);
    const { store } = this.context;
    let res;
    try {
      res = await store.dispatch(fetchM(`/mappings/affiliates/${this.props.params.affiliateMappingID}/`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: t('An error occurred, please refresh page', { ns: TRANSLATION_FILES.translation }) }));
      await this.setLoading(false);
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const token = res.headers.get('X-Csrf-Token');
      const data = await res.json();
      // handle token.. etc
      await this.setComponentState({
        token,
        data,
      });
    }
    await this.setLoading(false);
  }
  async fetchAffiliateMappings(q = {}) {
    const { t } = this.props;
    await this.setLoading(true);
    const { store } = this.context;
    const query = Object.assign({
      page: 1,
    }, q);
    let res;
    try {
      res = await store.dispatch(fetchM(`/mappings/affiliates/?${qs.stringify(query)}`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: t('An error occurred, please refresh page', { ns: TRANSLATION_FILES.translation }) }));
      await this.setLoading(false);
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const token = res.headers.get('X-Csrf-Token');
      // handle token.. etc
      await this.setComponentState({
        token,
      });
    }
    await this.setLoading(false);
  }
  renderChild() {
    return Children.map(this.props.children, child => (
      React.cloneElement(child, {
        token: this.state.token,
        loading: this.state.loading,
        data: this.state.data,
        affiliateMappingID: this.props.params.affiliateMappingID,
      })
    ));
  }
  render() {
    return (
      <div>
        {this.renderChild()}
      </div>
    );
  }
}

const TranslatedAffiliateMappings = withTranslation(namespaces)(AffiliateMappings);
TranslatedAffiliateMappings.List = AffiliateMappings.List;
TranslatedAffiliateMappings.New = AffiliateMappings.New;
TranslatedAffiliateMappings.Edit = AffiliateMappings.Edit;
export default TranslatedAffiliateMappings;



// WEBPACK FOOTER //
// ./src/containers/AffiliateMappings/AffiliateMappings.jsx